import {useState, useEffect} from 'react'
import {
  Box,
  Text,
  Flex,
  Avatar,
  Image,
  Icon,
  Stack,
  Tooltip,
  Center,
  Button,
} from '@chakra-ui/react'
import {NavLink, useNavigate} from 'react-router-dom'
import {EVENT_NAME, LOCAL_STORAGE, PATH, SCREEN_TRACKING} from '@utils/Const'
import {isLoggedIn, trackingEvent, trackingPage} from '@utils'
import {CommonColors} from '@utils/CommonStyles'
import Logo from '@assets/svgs/roadmap/logo.svg'
import MicIcon from '@assets/svgs/roadmap/mic.svg'
import {ReactComponent as Home} from '@assets/svgs/roadmap/home_line.svg'
import {ReactComponent as BarChart} from '@assets/svgs/roadmap/bar_chart_square.svg'
import {ReactComponent as Layers_three} from '@assets/svgs/roadmap/layers_three.svg'
import {ReactComponent as CheckDone} from '@assets/svgs/roadmap/check_done.svg'
import {ReactComponent as LogOut} from '@assets/svgs/roadmap/log_out.svg'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import Upgrade from '@assets/images/roadmap/upgrade.png'
import {
  updateEntryPointShowUpgradeModal,
  updateIsShowUpgradeModal,
} from '@redux/map/mapSlice'
import {useDispatch, useSelector} from 'react-redux'
import MenuIcon from '@assets/svgs/menu.svg'
import mapRequest from '@apis/map'
import {ReactComponent as Crown} from '@assets/svgs/roadmap/crown.svg'
import appRequest from '@apis/app'
import {Popover} from 'antd'
import {getUserId} from '@utils'
import {updateCurrentCourseId} from '@redux/shared/shared'

interface MenuItem {
  icon: any
  label: string
  path: string
  subItems?: any
}

const Sidebar = ({init}: {init: any}) => {
  const {currentCourseId} = useSelector((state: any) => state.shared)
  const [isSidebarVisible, setIsSidebarVisible] = useState(false)
  const retrievedToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
  const [isShowPreOrderBanner, setIsShowPreOrderBanner] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [profile, setProfile] = useState<any>()
  const [showCopyTooltip, setShowCopyTooltip] = useState(false)
  const [openMenus, setOpenMenus] = useState<{[key: string]: boolean}>({
    [PATH.HOME]: true,
  })

  const [menuItems, setMenuItems] = useState<MenuItem[]>([
    {
      icon: Home,
      label: 'Lộ trình',
      path: PATH.HOME,
      subItems: [],
    },
    {
      icon: BarChart,
      label: 'Chủ đề',
      path: PATH.LEARN,
    },
    {
      icon: Layers_three,
      label: 'Gym',
      path: PATH.GYM,
    },
    {
      icon: CheckDone,
      label: 'Phòng thi',
      path: PATH.EXAM,
    },
  ])

  useEffect(() => {
    getPreOrderBanner()
    getProfile()
    getCourses()
  }, [])

  const getProfile = async () => {
    if (!isLoggedIn()) return
    const res = await appRequest.getProfile()
    setProfile(res?.data?.data)
  }

  const getPreOrderBanner = async () => {
    if (!isLoggedIn()) return
    const res = await mapRequest.getPreOrderBanner()
    setIsShowPreOrderBanner(res?.data?.data?.is_show_banner)
  }

  const getCourses = async () => {
    const res = await mapRequest.getCourses()

    if (res?.data?.data) {
      const updatedMenuItems = menuItems.map(item => {
        if (item.path === PATH.HOME) {
          return {
            ...item,
            subItems: res.data.data.map((course: any) => ({
              label: course.course_name,
              path: PATH.HOME,
              course_id: course.course_id,
            })),
          }
        }
        return item
      })
      setMenuItems(updatedMenuItems)
    }
  }

  const handleGoHome = () => {
    navigate(PATH.HOME, {replace: true})
  }

  const handleLogout = () => {
    localStorage.clear()
    init()
    navigate(PATH.HOME, {replace: true})
    window.location.reload()
  }

  const handleClickUpgrade = () => {
    trackingPage(SCREEN_TRACKING.SALE_SCREEN_VIEW, {
      entry_point: 'sidebar',
    })
    trackingEvent(EVENT_NAME.SALE_ACTIVE_BUYER)
    dispatch(updateIsShowUpgradeModal(true))
    dispatch(updateEntryPointShowUpgradeModal('sidebar'))
  }

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible)
  }

  const toggleSubMenu = (path: string) => {
    setOpenMenus(prev => ({
      ...prev,
      [path]: !prev[path],
    }))
  }

  useEffect(() => {
    const sidebarElement = document.querySelector('.sidebar-desktop-menu')
    let touchStartX = 0
    let touchEndX = 0

    const handleTouchStart = (event: TouchEvent) => {
      touchStartX = event.changedTouches[0].screenX
    }

    const handleTouchEnd = (event: TouchEvent) => {
      touchEndX = event.changedTouches[0].screenX
      handleSwipeGesture()
    }

    const handleSwipeGesture = () => {
      if (touchStartX - touchEndX > 30) {
        setIsSidebarVisible(false)
      }
    }
    sidebarElement?.addEventListener(
      'touchstart',
      handleTouchStart as EventListener,
    )
    sidebarElement?.addEventListener(
      'touchend',
      handleTouchEnd as EventListener,
    )

    return () => {
      sidebarElement?.removeEventListener(
        'touchstart',
        handleTouchStart as EventListener,
      )
      sidebarElement?.removeEventListener(
        'touchend',
        handleTouchEnd as EventListener,
      )
    }
  }, [])

  useEffect(() => {
    const handleOverflow = () => {
      if (isSidebarVisible) {
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
      } else {
        document.body.style.overflow = ''
        document.body.style.position = ''
      }
    }

    handleOverflow()

    return () => {
      document.body.style.overflow = ''
      document.body.style.position = ''
    }
  }, [isSidebarVisible])

  const handleCopy = () => {
    const referralLink = window.location.origin + '?u=' + getUserId()
    navigator.clipboard.writeText(referralLink)
    setShowCopyTooltip(true)
    setTimeout(() => {
      setShowCopyTooltip(false)
    }, 3000)
  }

  const renderBanner = () => {
    return (
      <Box p={4}>
        <Image
          src={Upgrade}
          alt="Upgrade"
          w={'100%'}
          objectFit={'cover'}
          cursor={'pointer'}
          onClick={handleClickUpgrade}
          loading="lazy"
        />
      </Box>
    )
  }

  const closeAllMenus = () => {
    setOpenMenus({})
  }

  return (
    <>
      {isSidebarVisible && (
        <Box
          className="sidebar-overlay"
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bg="rgba(0, 0, 0, 0.5)"
          zIndex={999}
          onClick={toggleSidebar}
        />
      )}
      <Center
        className="sidebar-mobile-menu"
        display={{base: 'flex', md: 'none'}}
        position={'relative'}
        px={'16px'}
        pt={'8px'}>
        <Image
          src={MenuIcon}
          alt="Menu"
          w={'24px'}
          h={'24px'}
          position={'absolute'}
          cursor={'pointer'}
          left={'16px'}
          onClick={toggleSidebar}
        />
        <Flex
          w={'fit-content'}
          alignItems="center"
          cursor="pointer"
          onClick={handleGoHome}>
          <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
          <Image src={Logo} alt="IELTS Coach Logo" />
        </Flex>
      </Center>
      <Flex
        className="sidebar-desktop-menu"
        position={'fixed'}
        h={'100dvh'}
        left={{base: isSidebarVisible ? '0' : '-100%', md: '0'}}
        transition="left 0.3s ease-in-out"
        zIndex={1000}
        bg={'#f5f5f5'}>
        <Box
          width="256px"
          height="100dvh"
          boxShadow="md"
          display="flex"
          flexDirection="column">
          <Flex
            p={4}
            alignItems="center"
            cursor="pointer"
            onClick={handleGoHome}>
            <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
            <Image src={Logo} alt="IELTS Coach Logo" />
          </Flex>

          <Box as="nav" flexGrow={1}>
            <Stack spacing={2} px={4}>
              {menuItems.map((item, index) => (
                <Box key={index}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    onClick={() => item.subItems && toggleSubMenu(item.path)}
                    cursor={item.subItems ? 'pointer' : 'default'}>
                    <NavLink
                      to={item.path}
                      className={({isActive}) =>
                        isActive ? 'sidebar-item-active' : ''
                      }
                      style={({isActive}) => ({
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        backgroundColor: isActive ? CommonColors.primary : '',
                        color: isActive ? 'white' : '#182230',
                        flex: 1,
                      })}
                      onClick={e => {
                        if (item.subItems) {
                          e.preventDefault()
                        } else {
                          dispatch(updateCurrentCourseId(null))
                          closeAllMenus()
                        }
                        setIsSidebarVisible(false)
                      }}>
                      <Flex flex={1}>
                        <Icon
                          mr={2}
                          as={item.icon}
                          w={'24px'}
                          h={'24px'}
                          stroke="currentColor"
                        />
                        <Text fontSize="16px" fontWeight={600}>
                          {item.label}
                        </Text>
                      </Flex>
                      {item.subItems && (
                        <Box
                          sx={{
                            svg: {
                              transform: openMenus[item.path]
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                              transition: 'transform 0.2s',
                            },
                          }}>
                          <Icon
                            as={() => (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                  d="M6 9L12 15L18 9"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                            ml={2}
                          />
                        </Box>
                      )}
                    </NavLink>
                  </Flex>

                  {item.subItems && (
                    <Stack
                      pl={8}
                      mt={1}
                      spacing={1}
                      height={openMenus[item.path] ? 'auto' : '0'}
                      overflow="hidden"
                      transition="all 0.2s"
                      sx={{
                        'a:hover': {
                          color: 'unset !important',
                        },
                      }}>
                      {item.subItems.map((subItem: any, subIndex: any) => (
                        <NavLink
                          key={subIndex}
                          to={subItem.path}
                          style={{
                            padding: '8px',
                            borderRadius: '8px',
                            backgroundColor:
                              currentCourseId === subItem.course_id
                                ? '#dddddd'
                                : '',
                          }}
                          onClick={e => {
                            const isCurrentPath =
                              window.location.pathname === subItem.path
                            if (isCurrentPath) {
                              e.preventDefault()
                              dispatch(updateCurrentCourseId(subItem.course_id))
                            } else {
                              dispatch(updateCurrentCourseId(subItem.course_id))
                            }
                            setIsSidebarVisible(false)
                          }}>
                          <Text fontSize="14px" fontWeight={500}>
                            {subItem.label}
                          </Text>
                        </NavLink>
                      ))}
                    </Stack>
                  )}
                </Box>
              ))}
            </Stack>
          </Box>
          {isShowPreOrderBanner && renderBanner()}
          <Box p={4} borderTop="1px" borderColor="gray.200">
            {retrievedToken ? (
              <Flex alignItems="center">
                <Popover
                  trigger="click"
                  content={
                    <Box p={1}>
                      <Text
                        color={CommonColors.primary}
                        fontWeight={600}
                        fontSize={'18px'}>
                        {profile && profile?.expiration_date
                          ? 'Học viên IELTS'
                          : 'Học viên IELTS'}
                      </Text>
                      <Text fontWeight={600}>
                        {profile && profile?.expiration_date
                          ? 'Tài khoản Premium'
                          : 'Chưa nâng cấp premium'}
                      </Text>
                      <Flex alignItems={'center'} gap={2}>
                        <Text textDecoration={'underline'}>
                          Link giới thiệu của bạn
                        </Text>
                        <Tooltip
                          label="Đã sao chép"
                          placement="top"
                          isOpen={showCopyTooltip}>
                          <Button
                            h={'30px'}
                            cursor={'pointer'}
                            color={CommonColors.primary}
                            fontWeight={600}
                            border={'1px solid'}
                            borderRadius={'4px'}
                            py={0}
                            px={'8px'}
                            fontSize={'12px'}
                            onClick={handleCopy}>
                            Copy
                          </Button>
                        </Tooltip>
                      </Flex>
                    </Box>
                  }>
                  <Box position="relative" cursor="pointer">
                    <Avatar
                      className="sidebar-avatar"
                      src="https://bit.ly/broken-link"
                      bg={CommonColors.secondary}
                    />
                    {profile && profile?.expiration_date && (
                      <Center
                        position="absolute"
                        top="-7px"
                        right="-7px"
                        w="24px"
                        h="24px"
                        borderRadius="50%"
                        bg="#FFF3E0"
                        shadow="md">
                        <Icon
                          as={Crown}
                          position="absolute"
                          w="16px"
                          h="16px"
                          color={CommonColors.primary}
                        />
                      </Center>
                    )}
                  </Box>
                </Popover>

                <Box flex={1}></Box>
                <Tooltip label="Đăng xuất">
                  <Icon
                    className="sidebar-logout-icon"
                    as={LogOut}
                    ml={'12px'}
                    cursor="pointer"
                    w={'24px'}
                    h={'24px'}
                    onClick={handleLogout}
                  />
                </Tooltip>
              </Flex>
            ) : (
              <Flex justifyContent={'center'}>
                <GlobalButton onClick={() => navigate(PATH.LOGIN)}>
                  Đăng nhập
                </GlobalButton>
              </Flex>
            )}
          </Box>
        </Box>
      </Flex>
    </>
  )
}

export default Sidebar
